export const MaritalStatuses = [
  { value: "SI", text: 'مجرد' },
  { value: "MA", text: 'متاهل' },



]
const MaritalStatusSetter = (val) => {

  let value = null
  MaritalStatuses.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default MaritalStatusSetter;
